import styled from '@emotion/styled'
import { RESPONSIVE_BREAKPOINTS } from 'portal-modules/tenant-portal-layout/constants/responsive-breakpoints'
import { LEDGER_TOOLBAR_CONTROL_HEIGHT } from 'portal-modules/ledger/constants/keys'

// TP Ledger Tab Navigation styles. Extracted from LedgerTabnav.jsx so the
// component file holds rendering/wiring logic only.
export const StyledTPLedgerTabContainer = styled('div')`
  background: ${({ theme }) => theme.mode.tab_background_color};
  border-radius: ${({ theme }) => theme.mode.card_border_radius};
  padding: 4px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  /* Pinned to the shared toolbar control height so the pill group and the
     Download pill render at the same height and stay edge-aligned. The
     row's vertical spacing now lives on StyledTPLedgerToolbarRow. */
  height: ${LEDGER_TOOLBAR_CONTROL_HEIGHT};
  box-sizing: border-box;
`

export const StyledTPLedgerTabButton = styled('button')`
  background: ${({ isActive, theme }) =>
    isActive
      ? theme.mode.tab_active_background
      : theme.mode.tab_inactive_background};
  color: ${({ isActive, theme }) =>
    isActive
      ? theme.mode.tab_active_text_color
      : theme.mode.tab_inactive_text_color};
  border: none;
  border-radius: ${({ theme }) => theme.mode.card_border_radius};
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    background: ${({ isActive, theme }) =>
      isActive
        ? theme.mode.tab_active_background
        : theme.mode.isDark
          ? theme.mode.tab_hover_background_dark
          : theme.mode.tab_hover_background_light};
    color: ${({ isActive, theme }) =>
      isActive
        ? theme.mode.tab_active_text_color
        : theme.mode.isDark
          ? theme.text.white
          : theme.mode.tab_active_text_color};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px
      ${({ theme }) =>
        theme.mode.isDark
          ? theme.mode.tab_focus_shadow_dark
          : theme.mode.tab_focus_shadow_light};
  }
`

export const StyledTPLedgerTabNav = styled('nav')`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  margin: 0;
  width: 100%;
  box-sizing: border-box;

  @media ${RESPONSIVE_BREAKPOINTS.mobile.query} {
    justify-content: flex-start;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;

    ${StyledTPLedgerTabContainer} {
      min-width: max-content;
    }
  }
`
// TP Ledger toolbar row — keeps the scope pills on the left and the
// Download dropdown flush right on the same horizontal row, matching
// the prototype placement (PLACEMENT.md / DEV-293825).
export const StyledTPLedgerToolbarRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;
  /* Vertical rhythm is owned by the row (not by a single child), so both
     controls sit centered within the same band and align symmetrically. */
  margin: 16px 0;

  @media ${RESPONSIVE_BREAKPOINTS.mobile.query} {
    flex-direction: column;
    align-items: stretch;
  }
`

export const StyledTPLedgerDownloadSlot = styled('div')`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  @media ${RESPONSIVE_BREAKPOINTS.mobile.query} {
    align-self: flex-start;
  }
`

export const StyledH3 = styled('h3')`
  color: ${({ theme }) => theme.gray.dark};
  font-family: ${({ theme }) => theme.fonts.regular};
  height: 8px;
  width: 87px;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 19px;
  margin: 12px 0 20px 5px;
  @media only screen and (max-width: 576px) {
    margin: 30px 0 20px 24px;
  }
`
